import React, { useMemo, useRef } from 'react'
import { useDropzone } from 'react-dropzone'
import { Button } from 'react-bootstrap'

import '../App.css'

export const DROPZONE_WEBSITE_TYPE = 'WEBSITE'
export const DROPZONE_PDF_TYPE = 'PDF'
export const DROPZONE_PHP_TYPE = 'PHP'

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: 65,
  paddingBottom: 65,
  paddingLeft: 45,
  paddingRight: 45,
  borderWidth: 3,
  borderRadius: 18,
  borderColor: '#dc9bff',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  cursor: 'pointer'
}

const activeStyle = {
  borderColor: '#2196f3'
}

const acceptStyle = {
  borderColor: '#00e676'
}

const rejectStyle = {
  borderColor: '#ff1744'
}

const ICONS = {
  [DROPZONE_WEBSITE_TYPE]: 'generic-file.svg',
  [DROPZONE_PDF_TYPE]: 'generic-file.svg',
  [DROPZONE_PHP_TYPE]: 'generic-file.svg'
}

const getPlaceholder = (type, handleButtonClick) => {
  const icon = ICONS[type] || 'html-file.png'
  return (
    <>
      <div className="flex">
        {type !== 'ZIP' && (
          <>
            <img className="icon faded p-2" src="/assets/icons/zip-folder.png" alt="Zip" />
            <div className="ms-2 me-2" style={{ height: '40px', borderLeft: 'solid 1px #CBCBCB' }} />
            <img className="icon faded" src={`/assets/icons/${icon}`} alt="html file" />
          </>
        )}
        {type === 'ZIP' && <img className="icon faded p-2" src="/assets/icons/zip-folder.png" alt="Zip" />}
      </div>
      <div className="mt-2">
        {
          <span>
            {' '}
            Drag & drop zip or <br /> single file here
          </span>
        }
        <div className="d-flex flex-column align-items-center mt-3">
          <Button
            className="d-block ps-5 pe-5 pt-2 pb-2 bold dropzone-upload-btn"
            variant="purple"
            onClick={handleButtonClick}
          >
            Upload file
          </Button>
        </div>
      </div>
    </>
  )
}

const StyledDropzone = ({
  onFileSelect,
  className,
  type = DROPZONE_WEBSITE_TYPE,
  goToTemplateTab,
  acceptedFiles,
  testId,
  showExamples = true
}) => {
  const inputRef = useRef(null)
  const { getRootProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    onDrop: (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0 && onFileSelect) {
        onFileSelect(acceptedFiles)
      }
    },
    accept: acceptedFiles,
    noClick: true,
    noKeyboard: true,
    multiple: true
  })

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragAccept, isDragReject]
  )

  const handleButtonClick = () => {
    if (inputRef.current) {
      requestAnimationFrame(() => {
        inputRef.current.click()
      })
    }
  }

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || [])
    if (files.length > 0) {
      onFileSelect(files)
    }
  }

  const onExampleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (goToTemplateTab) {
      goToTemplateTab()
    }
  }

  return (
    <div className={`container-dropzone ${className || ''}`}>
      <div {...getRootProps({ style })}>
        <input
          ref={inputRef}
          type="file"
          multiple
          accept={acceptedFiles}
          onChange={handleFileChange}
          data-testid={testId}
          style={{ display: 'none' }}
        />
        {getPlaceholder(type, handleButtonClick)}
        <br></br>
        {showExamples && goToTemplateTab && (
          <span className="dark-grey">
            or use an <u onClick={onExampleClick}>example</u>
          </span>
        )}
      </div>
    </div>
  )
}

export default StyledDropzone
